import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetSeamVisionlineUserRequest = {
  clientId: string
}

export type SeamVisionlineEntrance = {
  id: string
  name: string
}

export type SeamVisionlineUser = {
  id: string
  clientId: number
  activationDate: string | null
  expirationDate: string | null
  entrances: SeamVisionlineEntrance[]
}

export const getSeamVisionlineUserQueryKey = (data: GetSeamVisionlineUserRequest) => [
  'useGetSeamVisionlineUser',
  data,
]

const getSeamVisionlineUser = async (data: GetSeamVisionlineUserRequest) => {
  const response = await authAPI.get<SeamVisionlineUser>(`/seam-visionline/users/${data.clientId}`)
  return response.data
}

export const useGetSeamVisionlineUser = (data: GetSeamVisionlineUserRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.clientId),
    queryFn: () => getSeamVisionlineUser(data),
    queryKey: getSeamVisionlineUserQueryKey(data),
  })
